const pageNameKey = "nameInputOurNode";

export const nameInputOurNodeEn = {
  [pageNameKey]: { saveButtonText: "Save" },
};

export const nameInputOurNodePtBr = {
  [pageNameKey]: { saveButtonText: "Salvar" },
};

export const nameInputOurNodeDe = {
  [pageNameKey]: { saveButtonText: "Speichern" },
};

export const nameInputOurNodeZhHans = {
  [pageNameKey]: { saveButtonText: "保存" },
};

export const nameInputOurNodeIt = {
  [pageNameKey]: { saveButtonText: "Salva" },
};

export const nameInputOurNodeEs = {
  [pageNameKey]: { saveButtonText: "Guardar" },
};

export const nameInputOurNodeNl = {
  [pageNameKey]: {
    saveButtonText: "Opslaan",
  },
};

export const nameInputOurNodeTr = {
  [pageNameKey]: {
    saveButtonText: "Kaydetmek",
  },
};
